
import MethodsPage from './MethodsPage';
export default MethodsPage;    
